export const getBreadcrumbStatus = (id: string) => {
  return id && id !== 'new' ? 'edit' : 'new';
};

export const isIFrame = (search: string): boolean => {
  return /iframe=true/.test(search);
};
